'use strict';
module.exports = require('./Listbox.vue');